// Slide layouts that render through SlideComponentV2 (and therefore support
// the inline edit toggle). Shared by the top slide-counter row (renders the
// edit button) and the slide switch below (picks the renderer).
export const V2_SUPPORTED_SLIDE_LAYOUTS = [
    'TemplateGraphicAndText',
    'TemplateList',
    'TemplateLongText',
    'TemplateStepBlock',
    'TemplateSessionStart',
    'TemplateHtmlContent',
    'PledgeTemplate',
    'VideoTemplate',
    'JOURNALING_SELF_REFLECTION_ACTIVITY',
    'SHARE_WORK_FILE_ACTIVITY',
    'POLL_QUIZ_ACTIVITY',
    'DISCUSSION_ACTIVITY',
    'ASSESSMENT_RESULT',
    'TEMPLATE_WITH_SUBTITLE',
    'TemplateRecap',
    'TemplateReentryMap',
    'TemplateWorkedExample',
    'TemplateDecisionPoint',
    'TemplateAnalysisFramework',
];

export const SLIDE_TYPE_LAYOUT_MAP = {
    intro_video: 'VideoTemplate',
    video: 'VideoTemplate',
    poll: 'POLL_QUIZ_ACTIVITY',
    intro_poll: 'POLL_QUIZ_ACTIVITY',
    tied_poll: 'POLL_QUIZ_ACTIVITY',
    fun_poll: 'POLL_QUIZ_ACTIVITY',
    poll_quiz: 'POLL_QUIZ_ACTIVITY',
    group_discussion: 'DISCUSSION_ACTIVITY',
    discussion: 'DISCUSSION_ACTIVITY',
    journaling: 'JOURNALING_SELF_REFLECTION_ACTIVITY',
    reflection: 'JOURNALING_SELF_REFLECTION_ACTIVITY',
    share_work: 'SHARE_WORK_FILE_ACTIVITY',
    pledge: 'PledgeTemplate',
    recap: 'TemplateRecap',
    t7_recap: 'TemplateRecap',
    reentry_map: 'TemplateReentryMap',
    decision_point: 'TemplateDecisionPoint',
    worked_example: 'TemplateWorkedExample',
    analysis_framework: 'TemplateAnalysisFramework',
    case_study: 'TemplateHtmlContent',
    celebration: 'TemplateHtmlContent',
    badge: 'TemplateHtmlContent',
    summary: 'TemplateHtmlContent',
};
